// Guard que se compone después de ProtectedRoute. Si el usuario tiene >1
// tenant disponible y todavía NO eligió uno (no hay `active_tenant_id` en su
// `user_metadata`), lo redirige a /elegir-tenant.
//
// Para usuarios con 1 solo tenant, el hook GoTrue ya eligió automáticamente y
// no hace falta L0 — este guard los deja pasar.
//
// El `active_tenant_id` se setea en `user_metadata` cuando el usuario hace
// click en una opción de L0 (ver `ChooseTenantPage`). Después de eso, el JWT
// se refresca y este guard los deja entrar al home.

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

interface ActiveTenantMetadata {
  active_tenant_id?: string;
}

export function RequireTenantChosen({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  const location = useLocation();

  // ProtectedRoute ya corrió antes — confiamos en que state.kind === 'signed_in'.
  // Defensivo: si no, dejamos pasar (la siguiente capa lo maneja).
  if (state.kind !== 'signed_in') return <>{children}</>;

  // Caso simple: solo 1 tenant → no hay nada que elegir
  if (state.claims.tenants_disponibles.length <= 1) return <>{children}</>;

  // Multi-tenant: ¿ya eligió uno?
  const metadata = state.session.user.user_metadata as ActiveTenantMetadata | undefined;
  if (metadata?.active_tenant_id) return <>{children}</>;

  // Multi-tenant + sin elección → ir a L0 (preservando ruta destino)
  return <Navigate to="/elegir-tenant" state={{ from: location }} replace />;
}
